import "@/App.css";

function App() {
  return (
    <main
      style={{
        minHeight: "100vh",
        background: "#02050b",
        color: "#f7f3ea",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "32px",
        textAlign: "center",
        fontFamily:
          "Inter, system-ui, -apple-system, BlinkMacSystemFont, sans-serif",
      }}
    >
      <section>
        <p
          style={{
            margin: "0 0 12px",
            fontSize: "20px",
            lineHeight: 1.6,
            color: "rgba(247, 243, 234, 0.82)",
            fontWeight: 500,
          }}
        >
          For enquiries, please contact:
        </p>

        <a
          href="mailto:info@imac.ist"
          style={{
            color: "#75d7ec",
            textDecoration: "none",
            fontSize: "24px",
            fontWeight: 600,
            letterSpacing: "0.01em",
          }}
        >
          info@imac.ist
        </a>
      </section>
    </main>
  );
}

export default App;
